import { gql } from "@apollo/client/core";

export default gql`
    fragment GuaranteeCategory on GuaranteeCategory {
        id
        title
        description
    }
`
